<template>
  <div class="tile status-block" :id="service.name">
    <h3 class="content__heading">{{ service.name }}</h3>
    <p class="flex__between tile--row pointer">
      <span class="text__bold">Status:</span>
      <span class="flex__center" v-if="!editing" @click="toggleEditing">
        <span class="status-block--status">{{ service.is_complete ? "Completed" : "Incomplete" }}</span>
        <span class="status-edit">
          <font-awesome-icon icon="edit" size="md" />Edit
        </span>
      </span>
      <select v-else v-model="form.is_complete">
        <option :value="true">Complete</option>
        <option :value="false">Incomplete</option>
      </select>
    </p>
    <p v-if="editing" class="flex__between tile--row status-block--buttons">
      <button class="btn btn__red" @click.stop="cancelEdit">Cancel</button>
      <button class="btn btn__green" @click.stop="submitEdits">Done</button>
    </p>
    <Comments
      :comments="filteredComments"
      :service="service"
      :type="type"
      :name="shortUsername"
      @addComment="handleAddComment"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Comments from "./Comments";
import { db } from "../../firebase/firestore";
export default {
  props: ["service", "type", "namespace"],
  components: {
    Comments
  },
  data() {
    return {
      form: {
        _id: this.service._id,
        name: this.service.name,
        is_complete: this.service.is_complete,
        request_id: this.service.request_id,
        request_type: this.service.request_type,
        active: this.service.active
      },
      editing: false,
      comments: []
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
    shortUsername() {
      const names = this.getUser.username.split(" ");
      const first = names[0];
      const lastInit = names[1].substring(0, 1);
      return `${first} ${lastInit}`;
    },
    filteredComments() {
      return this.comments
        .map(comment => {
          comment.submitted = moment(comment.submitted, [
            "MM-DD-YYYY h:mm:ss a"
          ]).format("MM-DD-YYYY hh:mm:ss a");
          return comment;
        })
        .filter(comment => {
          return (
            comment.request_id === this.service.request_id &&
            comment.request_type === this.type &&
            comment.service_name === this.service.name
          );
        })
        .sort((a, b) => {
          if (a.submitted < b.submitted) {
            return 1;
          } else if (a.submitted > b.submitted) {
            return -1;
          } else {
            return 0;
          }
        });
    }
  },
  methods: {
    toggleEditing() {
      if (!this.editing) {
        this.editing = !this.editing;
      }
    },
    cancelEdit() {
      this.editing = !this.editing;
    },
    async submitEdits() {
      this.editing = !this.editing;
      try {
        await this.$store.dispatch(
          `${this.namespace}/startUpdateRequest`,
          this.form
        );
        const changeComment = {
          submitted: moment().format("MM-DD-YYYY h:mm:ss a"),
          request_id: this.form.request_id,
          request_type: this.type,
          commenter_name: this.shortUsername,
          service_name: this.service.name,
          content: `Status changed to ${
            this.form.is_complete ? "COMPLETE" : "INCOMPLETE"
          }`,
          status_change: true
        };
        await db.collection("comments").add(changeComment);
      } catch (err) {
        this.flash("Error commenting: " + err, "error");
      }
    },
    async handleAddComment(newComment) {
      await db.collection("comments").add(newComment);
    }
  },
  created() {
    this.$bind("comments", db.collection("comments"));
  }
};
</script>

<style scoped lang="scss">
.status-block--status {
  padding: 10px;
}
.status-block--buttons {
  margin-top: 20px;
  margin-bottom: 30px;
}
.status-edit {
  color: $green;
  font-size: $text-regular;
}
</style>